import api from "./api";

const KEY = "cen21_offline_movements";

export const readQueue = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const writeQueue = (q) => localStorage.setItem(KEY, JSON.stringify(q));

export function enqueueMovement(payload, signatureDataUrl) {
  const q = readQueue();
  q.push({ id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, payload, signatureDataUrl, queued_at: new Date().toISOString() });
  writeQueue(q);
  return q.length;
}

export const isNetworkError = (err) => !err.response;

let syncing = false;

export async function syncQueue() {
  if (syncing) return { synced: 0, remaining: readQueue().length, busy: true };
  syncing = true;
  try {
    const q = readQueue();
    if (!q.length) return { synced: 0, remaining: 0, errors: [] };
    let synced = 0;
    const remaining = [];
    const errors = [];
    for (const item of q) {
      try {
        let signature = null;
        if (item.signatureDataUrl) {
          const blob = await (await fetch(item.signatureDataUrl)).blob();
          const fd = new FormData();
          fd.append("file", blob, `signature-${item.id}.png`);
          const { data } = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
          signature = data;
        }
        await api.post("/movements", { ...item.payload, signature, notes: `${item.payload.notes || ""} [hors-ligne ${item.queued_at.slice(0, 16).replace("T", " ")}]`.trim() });
        synced++;
      } catch (err) {
        if (isNetworkError(err)) { remaining.push(item); continue; }
        const status = err.response?.status;
        if (status === 401 || status >= 500) { remaining.push(item); continue; }
        // 4xx business error: drop item but report it
        errors.push({ item, detail: err.response?.data?.detail });
      }
    }
    writeQueue(remaining);
    return { synced, remaining: remaining.length, errors };
  } finally {
    syncing = false;
  }
}
